'use strict'

import React from 'react'

const Footer = () => {
  return (
    <div className='flex mt-12 mb-2'>
      <span className='mx-auto'>
        Made with&nbsp;
        <span className='text-red-700'>♥</span>&nbsp; by&nbsp;
        <a
          href='https://jagonzalr.com'
          rel='noopener noreferrer'
          target='_blank'
          className='hover:text-blue-400'
        >
          jagonzalr
        </a>
      </span>
    </div>
  )
}

export default Footer
